import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

/**
 * Confirmation dialog for deleting a subscription.
 */
export default function DeleteSubscriptionDialog({
  open,
  onClose,
  onConfirm,
  subscription = null,
}) {
  const displayName = subscription
    ? subscription.name || subscription.subscription_type || subscription.plan_name || "this subscription"
    : "this subscription";

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Subscription</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete <strong>{displayName}</strong>? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
